import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import "./mediaGalleryItem.scss";

const MediaGalleryItem = ({
  download = null,
  headline,
  description,
  media = null,
}) => (
  <div className="media-gallery-item">
    <div className="media-gallery-item__image-container">
      <div
        className={classNames(
          "media-gallery-item__image",
          {
            "placeholder-image placeholder-image--article": !media,
          },
        )}
      >
        {media}
      </div>
    </div>
    <div className="media-gallery-item__headline">
      {headline}
    </div>
    <div className="typo-body1">
      {description}
    </div>
    {download}
  </div>
);

MediaGalleryItem.propTypes = {
  description: PropTypes.node.isRequired,
  download: PropTypes.oneOfType([PropTypes.object]),
  headline: PropTypes.string.isRequired,
  media: PropTypes.oneOfType([PropTypes.object]),
};

export default MediaGalleryItem;
